import "../../styles/results/about.scss";
import "../../styles/users/favourites.scss";
import "../../styles/map-only.scss";
import "../../styles/establishment-only.scss";
import { bind_swiper } from "../integration/swiper";
import "../integration/leaflet/leaflet-wrapper";
import lightGallery from 'lightgallery';
window.lightGallery = lightGallery;
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import chevronLeftIcon from '../../images/icons/chevron-left.svg';
import chevronRightIcon from '../../images/icons/chevron-right.svg';

bind_swiper('.js-swiper-main');

const lgDesktop = document.getElementById('js-lightgallery-sixteen-by-nine');

if (lgDesktop !== undefined && lgDesktop !== null) {
    lightGallery(lgDesktop, {
        selector: '.js-lightgallery-item:not(.swiper-slide-duplicate)',
        download: false,
        enableDrag: false,
        startClass: '',
        speed: 100,
        mode: 'lg-fade',
        toggleThumb: true,
        prevHtml: `<img src="${chevronLeftIcon}" alt="Previous" class="lg-nav-icon"/>`,
        nextHtml: `<img src="${chevronRightIcon}" alt="Next" class="lg-nav-icon"/>`,
        hideBarsDelay: 2147483647,
        thumbnail: false,
        allowMediaOverlap: true,
        exThumbImage: 'data-src-thumb',
        mobileSettings: {
            controls: true,
        },
        licenseKey : '2A817ACD-5CE44491-98878891-437B3F14',
        supportLegacyBrowser : false,
        plugins:[lgThumbnail]
    });
}

document.addEventListener('click', function (event) {
    const el = /** @type {HTMLTextAreaElement} */ (event.target);
    // Hack to enable duplicates to function as they are not bound with lighgallery on purpose
    if (el.classList.contains('swiper-lazy') && el.parentElement.classList.contains('swiper-slide-duplicate')) {
        if (el.parentElement.getAttribute('data-swiper-slide-index') !== null) {
            const imageIndex = parseInt(el.parentElement.getAttribute('data-swiper-slide-index')) + 1;
            let roomOrMainSwiper = el.classList.contains('js-room');
            let swiperWrapper = el.closest(".swiper-wrapper");
            if (swiperWrapper) {
                let galleryItemClass = roomOrMainSwiper ? '.js-lightgallery-room-item' : '.js-lightgallery-item';
                let lgItems = swiperWrapper.querySelectorAll(galleryItemClass);

                if (lgItems[imageIndex]) {
                    simulateClick(lgItems[imageIndex]);
                }
            }
        }
    } else if (el.classList.contains('js-sidebar-gallery-image')) {
        const imageIndex = el.getAttribute('data-image-id');
        let lgItems = document.querySelectorAll('#js-lightgallery-sixteen-by-nine .js-lightgallery-item');

        // In case js-lightgallery-sixteen-by-nine is not present, check if js-lightgallery-four-by-three is present
        if (lgItems.length < 1 || lgItems === null || lgItems === undefined) {

            lgItems = document.querySelectorAll('#js-lightgallery-four-by-three .js-lightgallery-item');
        }

        // Do not allow to click if there isn't anything
        if (lgItems.length > 0 && lgItems !== null && lgItems !== undefined) {
            simulateClick(lgItems[imageIndex]);
        }
    }
}, false);



let simulateClick = function (elem) {
    // Create our event (with options)
    var evt = document.createEvent('MouseEvent');
    evt.initMouseEvent(
        'click',
        true, /* bubble */
        true, /* cancelable */
        window, null,
        0, 0, 0, 0, /* coordinates */
        false, false, false, false, /* modifier keys */
        0,/*left*/
        null
    );

    let canceled = !elem.dispatchEvent(evt);
};

// Preload images fucntion
function preloadImage(img) {
    const src = img.getAttribute('data-src');
    if (!src) {
        return;
    }
    img.src = src;
}

// Lazy load Sidebar
const images = document.querySelectorAll('.image-lazy');
const config = {
    rootMargin: '0px 0px 100px 0px', // increase 100px to auto load images earlier out of viewport
    threshold: 0
};

let observer = new IntersectionObserver(function (entries, self) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            preloadImage(entry.target);
            // Stop watching and load the image
            self.unobserve(entry.target);
        }
    });
}, config);

images.forEach(image => {
    observer.observe(image);
});

// Initialise map for attraction about pages
const tabMap = document.getElementById("js-map-tab-canvas");

if (tabMap) {
    const latitude = tabMap.dataset.latitude;
    const longitude = tabMap.dataset.longitude;
    const leafletMap = window.tg.leafletMap;

    leafletMap.initialize([parseFloat(latitude), parseFloat(longitude)], { 'identifier': 'js-map-tab-canvas' });
}
